__turbopack_context__.v({
  "error": "Input-module-scss-module__setMjW__error",
  "input": "Input-module-scss-module__setMjW__input",
  "slot": "Input-module-scss-module__setMjW__slot",
  "wrapper": "Input-module-scss-module__setMjW__wrapper",
});
